import { gql } from '@apollo/client'

export const workspaceUpsertOne = gql`
  mutation WorkspaceUpsertOne($record: WorkspaceInput!) {
    workspaceUpsertOne(record: $record)
  }
`
